export enum RoofStyle {
  Gable = 'gable', // ranch
  Gambrel = 'gambrel',
  Shed = 'shed', // lean
  SaltBox = 'saltbox',
}
